import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/components/ExpandableText.css";

export default function ExpandableText({ text, maxChars = 120 }) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  const isLong = text.length > maxChars;
  const short = text.slice(0, maxChars);

  return (
    <div className="expandable-text-wrapper">
      {!expanded ? (
        // 🔹 SINGLE-LINE MODE
        <div className="expandable-text-collapsed">
          {/* TEXT part — gets truncated */}
          <span className="expandable-text-short">
            {short}
          </span>

          {/* READ MORE BUTTON — stays at right end */}
          {isLong && (
            <span
              className="expandable-text-toggle"
              onClick={() => setExpanded(true)}
            >
              {t("read_more")}
            </span>
          )}
        </div>
      ) : (
        // 🔹 EXPANDED MULTILINE MODE
        <div className="expandable-text-expanded">
          {text}
          <span
            className="expandable-text-toggle-expanded"
            onClick={() => setExpanded(false)}
          >
            {t("show_less")}
          </span>
        </div>
      )}
    </div>
  );
}
